export { default as TranslateIcon } from './TranslateIcon';
